import request from '~/utils/http';
// 供应商列表
export function getSupplier() {
  return request({
    url: 'api/Supplier/GetList',
    method: 'post',
    data: {}
  })
}
// 供应商账户
export function getSupplierBank() {
  return request({
    url: 'api/SupplierBank/GetList',
    method: 'post',
    data: {}
  })
}
// 供应商提货地址
export function getSupplierAddress() {
  return request({
    url: 'api/SupplierRecipient/GetList',
    method: 'post',
    data: {}
  })
}

export function addSupplier(sendData) {
  return request({
    url: 'api/Supplier/Add',
    method: 'post',
    data: sendData
  })
}

export function getSuppliers() {
  return request({
    url: 'api/Supplier/GetSuppliers',
    method: 'post',
    data: {}
  })
}

//获取某个供应商提货地址
export function getSupplierAddressById(sendData) {
  return request({
    url: 'api/SupplierRecipient/GetListBySupplier',
    method: 'post',
    data: sendData
  })
}

export function addSupplierAddress(sendData) {
  return request({
    url: 'api/SupplierRecipient/Add',
    method: 'post',
    data: sendData
  })
}